(() => {
  const selector = document.querySelector('[js-more-shirts-selector]');
  const popup = document.querySelector('[js-shirt-pdp-popup]');
  if (!selector || !popup) return;

  const track = selector.querySelector('[js-more-shirts-track]');
  const prevBtn = selector.querySelector('[js-more-shirts-prev]');
  const nextBtn = selector.querySelector('[js-more-shirts-next]');
  const body = popup.querySelector('[js-shirt-pdp-popup-body]');
  const closeBtns = popup.querySelectorAll('[js-shirt-pdp-close]');

  const updateHeaderZIndex = (isOpen) => {
    const headerStickies = document.querySelectorAll(
      '.template--bridal.collection_header_transparent_new .shopify-section-header-sticky, .shopify-section-header-sticky'
    );
    headerStickies.forEach((header) => {
      if (isOpen) {
        header.style.setProperty('z-index', '1', 'important');
      } else {
        header.style.removeProperty('z-index');
      }
    });
  };

  const openPopup = () => {
    popup.classList.add('popup-open');
    document.body.classList.add('popup-active');
    updateHeaderZIndex(true);
  };

  const closePopup = () => {
    popup.classList.remove('popup-open', 'is-loading');
    document.body.classList.remove('popup-active');
    updateHeaderZIndex(false);
  };

  const updateNav = () => {
    if (!track || !prevBtn || !nextBtn) return;
    const maxScroll = track.scrollWidth - track.clientWidth - 4;
    const canScroll = maxScroll > 0;
    prevBtn.hidden = !canScroll;
    nextBtn.hidden = !canScroll;
    prevBtn.disabled = track.scrollLeft <= 4;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  };

  const scrollByCard = (direction) => {
    const card = track.querySelector('.more-shirts-selector__item');
    const amount = card ? card.getBoundingClientRect().width + 10 : 100;
    track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  };

  const initAccordion = (root) => {
    root.querySelectorAll('[js-shirt-accordion-header]').forEach((header) => {
      header.addEventListener('click', () => {
        const item = header.closest('.js-accordion-item');
        const isOpen = item.classList.contains('active');
        root.querySelectorAll('.js-accordion-item').forEach((el) => {
          el.classList.remove('active');
          const panel = el.querySelector('[js-shirt-accordion-body]');
          if (panel) panel.hidden = true;
        });
        if (!isOpen) {
          item.classList.add('active');
          const panel = item.querySelector('[js-shirt-accordion-body]');
          if (panel) panel.hidden = false;
        }
      });
    });

    root.querySelectorAll('[js-shirt-product-desc]').forEach((wrap) => {
      const shortDes = wrap.querySelector('.short_des');
      const longDes = wrap.querySelector('.long_des');
      if (!shortDes || !longDes) return;
      wrap.querySelectorAll('.desc_more').forEach((btn) => {
        btn.addEventListener('click', () => {
          const showLong = btn.closest('.short_des');
          shortDes.hidden = Boolean(showLong);
          longDes.hidden = !showLong;
          if (showLong) longDes.removeAttribute('style');
        });
      });
    });
  };

  const addBusinessDays = (numDaysToAdd) => {
    const date = new Date();
    let daysRemaining = parseInt(numDaysToAdd, 10);
    if (Number.isNaN(daysRemaining)) daysRemaining = 3;
    while (daysRemaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) {
        daysRemaining -= 1;
      }
    }
    return date;
  };

  const addExpressDays = (startDate, extraDays) => {
    const date = new Date(startDate);
    let daysRemaining = parseInt(extraDays, 10);
    if (Number.isNaN(daysRemaining)) daysRemaining = 0;
    let firstWeekendSkipped = false;
    while (daysRemaining > 0) {
      const day = date.getDay();
      if (!firstWeekendSkipped && (day === 6 || day === 0)) {
        date.setDate(date.getDate() + 1);
        if (day === 0) {
          firstWeekendSkipped = true;
        }
        continue;
      }
      daysRemaining -= 1;
      date.setDate(date.getDate() + 1);
    }
    while (!firstWeekendSkipped && (date.getDay() === 6 || date.getDay() === 0)) {
      if (date.getDay() === 0) firstWeekendSkipped = true;
      date.setDate(date.getDate() + 1);
    }
    return date;
  };

  const formatDeliveryDate = (date) => {
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const day = date.getDate();
    return `${weekdays[date.getDay()]}, ${day} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const setShirtDelivery = (root, input) => {
    const container = root.querySelector('[js-shirt-delivery-container]');
    if (!container) return;

    const expressWrap = container.querySelector('[js-shirt-delivery-wrapper-express]');
    const mtoWrap = container.querySelector('[js-shirt-delivery-wrapper-mto]');
    const expressTimeEl = container.querySelector('[js-shirt-express-delivery-time]');
    const defaultTimeEl = container.querySelector('[js-shirt-default-delivery-time]');
    const mtoTimeEl = container.querySelector('[js-shirt-delivery-time]');
    

    const internationalExtraDays = parseInt(container.dataset.internationalExtraDays || '0', 10) || 0;
    const expressExtraDays = parseInt(container.dataset.expressExtraDays || '3', 10) || 3;
    const rtsDays = parseInt(input?.dataset.deliveryDaysRts || container.dataset.rtsDays || '0', 10) || 0;
    const mtoDays = parseInt(input?.dataset.deliveryDaysMto || container.dataset.mtoDays || '15', 10) || 15;
    const qty = input ? parseInt(input.dataset.variantQuantity || '0', 10) : 0;
    

    const isMTO = !input || qty < 1 || input.dataset.deliveryType === 'MTO';

    if (isMTO) {
      if (expressWrap) expressWrap.classList.add('hidden');
      if (mtoWrap) mtoWrap.classList.remove('hidden');

      const mtoDate = addBusinessDays(mtoDays + internationalExtraDays);
      const formattedMtoDate = formatDeliveryDate(mtoDate);
      if (mtoTimeEl) mtoTimeEl.textContent = formattedMtoDate;

      
    } else {
      if (expressWrap) expressWrap.classList.remove('hidden');
      if (mtoWrap) mtoWrap.classList.add('hidden');
      

      const expressDate = addExpressDays(new Date(), rtsDays + internationalExtraDays);
      const standardDate = addExpressDays(new Date(), rtsDays + internationalExtraDays + expressExtraDays);

      if (expressTimeEl) expressTimeEl.textContent = formatDeliveryDate(expressDate);
      if (defaultTimeEl) defaultTimeEl.textContent = formatDeliveryDate(standardDate);
    }
  };

  const formatCurrency = (amountInCents, symbol) => {
    const val = amountInCents / 100;
    const formatted = val.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    return (symbol || '£') + formatted;
  };

  const setShirtPrice = (root, input) => {
    if (!input) return;
    const priceRaw = parseInt(input.dataset.variantPrice || '0', 10);
    const compareRaw = parseInt(input.dataset.variantCompare || '0', 10);
    const formattedPrice = input.dataset.variantPriceFormatted;
    const formattedCompare = input.dataset.variantCompareFormatted;
    const showDiscountAmount = input.dataset.variantShowDiscount === 'true';

    const atcPrice = root.querySelector('[js-shirt-atc-price], [js-pdp-original-price]');
    if (atcPrice && formattedPrice) atcPrice.textContent = formattedPrice;

    const priceRoot = root.querySelector('[js-shirt-price]');
    if (!priceRoot) return;

    const priceContainer = priceRoot.querySelector('.price');
    const symbol =
      priceContainer?.dataset.shopCurrency ||
      (document.querySelector('[data-shop-currency]') || {}).dataset?.shopCurrency ||
      '£';

    const isOnSale = compareRaw > priceRaw && compareRaw > 0;
    if (priceContainer) {
      priceContainer.classList.toggle('price--on-sale', isOnSale);
    }

    if (isOnSale) {
      const salePriceEl = priceRoot.querySelector('.price__sale .price-item--sale');
      if (salePriceEl && formattedPrice) {
        salePriceEl.textContent = formattedPrice;
        salePriceEl.setAttribute('data-pdp-product-price', formattedPrice.replace(/[^\d.,]/g, ''));
      }

      const comparePriceEl = priceRoot.querySelector('.price__sale s.price-item--regular');
      if (comparePriceEl && formattedCompare) {
        comparePriceEl.innerHTML = `MRP ${formattedCompare}`;
        comparePriceEl.setAttribute('data-compare-at-price', formattedCompare.replace(/[^\d.,]/g, ''));
      }

      let discountLabel = '';
      const saving = compareRaw - priceRaw;
      const pct = Math.round((saving / compareRaw) * 100);
      const percentageLabel = `${pct}% OFF`;

      if (showDiscountAmount) {
        discountLabel = `${formatCurrency(saving, symbol)} OFF`;
      } else {
        discountLabel = percentageLabel;
      }

      const saveWrap = priceRoot.querySelector('.Product_price_save_new');
      if (saveWrap) {
        saveWrap.style.display = '';
        const labelEl = saveWrap.querySelector('.Product_price_save_label');
        const savingEl = saveWrap.querySelector('.data-saving-pdp');
        if (labelEl) labelEl.textContent = discountLabel;
        if (savingEl) savingEl.setAttribute('data-saving', discountLabel);
      }

      const savingPriceInput = root.querySelector('[js-shirt-saving-price]');
      if (savingPriceInput) {
        savingPriceInput.value = percentageLabel;
        savingPriceInput.removeAttribute('disabled');
      }
    } else {
      const regPriceEl = priceRoot.querySelector('.price__regular .price-item--regular');
      if (regPriceEl && formattedPrice) {
        regPriceEl.innerHTML = `<span class="price-mrp">MRP</span> ${formattedPrice}`;
        regPriceEl.setAttribute('data-pdp-product-price', formattedPrice.replace(/[^\d.,]/g, ''));
      }

      const saveWrap = priceRoot.querySelector('.Product_price_save_new');
      if (saveWrap) {
        saveWrap.style.display = 'none';
      }

      const savingPriceInput = root.querySelector('[js-shirt-saving-price]');
      if (savingPriceInput) {
        savingPriceInput.value = '';
        savingPriceInput.setAttribute('disabled', '');
      }
    }
  };

  const setShirtSku = (root, input) => {
    const skuEl = root.querySelector('[js-shirt-sku]');
    if (!skuEl || !input) return;
    const variantSku = input.dataset.variantSku;
    if (variantSku) {
      skuEl.textContent = `SKU: ${variantSku}`;
      skuEl.style.display = '';
    }
  };

  const setShirtReturnable = (root, input) => {
    const details = root.querySelector('[js-shirt-product-details]');
    if (!details || !input) return;
    details.classList.remove('non-returnable-variant', 'returnable-variant');
    if (input.dataset.returnable === 'false') {
      details.classList.add('non-returnable-variant');
    } else if (input.dataset.returnable === 'true') {
      details.classList.add('returnable-variant');
    }
  };

  const initSizeGuideModal = (root) => {
    const openBtn = root.querySelector('[js-shirt-size-guide-btn]');
    const modal = root.querySelector('[js-shirt-size-chart-modal]');
    if (!openBtn || !modal) return;

    const closeBtns = modal.querySelectorAll('[js-shirt-size-chart-close]');
    const inchBtn = modal.querySelector('[js-shirt-size-convert-btn-inch]');
    const cmBtn = modal.querySelector('[js-shirt-size-convert-btn-cm]');
    const images = modal.querySelectorAll('[js-shirt-size-chart-image]');

    const setUnit = (unit) => {
      if (inchBtn && cmBtn) {
        inchBtn.classList.toggle('active', unit === 'in');
        cmBtn.classList.toggle('active', unit === 'cm');
      }
      images.forEach((img) => {
        if (img.getAttribute('data-parameter') === unit) {
          img.classList.remove('visually-hide');
        } else {
          img.classList.add('visually-hide');
        }
      });
    };

    const openModal = () => {
      setUnit('in');
      modal.classList.remove('hide');
    };

    const closeModal = () => {
      modal.classList.add('hide');
    };

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });
    });

    if (inchBtn) {
      inchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        setUnit('in');
      });
    }

    if (cmBtn) {
      cmBtn.addEventListener('click', (e) => {
        e.preventDefault();
        setUnit('cm');
      });
    }
  };

  const initSizePicker = (root) => {
    const variantInput = root.querySelector('input.product-variant-id');
    const checkedInput = root.querySelector('[js-shirt-size-input]:checked');
    if (checkedInput) {
      setShirtDelivery(root, checkedInput);
      setShirtPrice(root, checkedInput);
      setShirtSku(root, checkedInput);
      setShirtReturnable(root, checkedInput);
    } else {
      setShirtDelivery(root, null);
    }

    root.querySelectorAll('[js-shirt-size-input]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        if (variantInput) variantInput.value = input.dataset.variantId;
        setShirtPrice(root, input);
        setShirtSku(root, input);
        setShirtDelivery(root, input);
        setShirtReturnable(root, input);
      });
    });
  };

  const initShirtForm = (root) => {
    const form = root.querySelector('[js-shirt-atc-form], form[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const submitButton = form.querySelector('[type="submit"]');
      const spinner = form.querySelector('.loading__spinner');
      const sizeInputs = form.querySelectorAll('[js-shirt-size-input]');
      const selectedSize = form.querySelector('[js-shirt-size-input]:checked');
      const variantInput = form.querySelector('.product-variant-id');

      if (sizeInputs.length && !selectedSize) {
        form.reportValidity();
        return;
      }

      if (selectedSize && variantInput) {
        variantInput.value = selectedSize.dataset.variantId;
        variantInput.removeAttribute('disabled');
      }

      const formData = new FormData(form);
      formData.set('items[0][id]', variantInput ? variantInput.value : formData.get('id'));
      formData.set('items[0][quantity]', '1');
      formData.delete('id');

      if (selectedSize) {
        const compareRaw = parseInt(selectedSize.dataset.variantCompare || '0', 10);
        const priceRaw = parseInt(selectedSize.dataset.variantPrice || '0', 10);
        const showDiscountAmount = selectedSize.dataset.variantShowDiscount === 'true';
        if (compareRaw > priceRaw && compareRaw > 0) {
          const pct = Math.round(((compareRaw - priceRaw) / compareRaw) * 100);
          const saveVal = `${pct}% OFF`;
          formData.set('items[0][properties[saving_price]]', saveVal);
          formData.set('items[0][properties][saving_price]', saveVal);
        } else {
          formData.delete('items[0][properties[saving_price]]');
          formData.delete('items[0][properties][saving_price]');
        }

        const container = root.querySelector('[js-shirt-delivery-container]');
        const rtsDays = selectedSize.dataset.deliveryDaysRts || container?.dataset.rtsDays || '3';
        const mtoDays = selectedSize.dataset.deliveryDaysMto || container?.dataset.mtoDays || '15';
        formData.set('items[0][properties][_Delivery days mto]', mtoDays);
        formData.set('items[0][properties][_Delivery days rts]', rtsDays);

        const isMTO = parseInt(selectedSize.dataset.variantQuantity || '0', 10) < 1 || selectedSize.dataset.deliveryType === 'MTO';
        const expressTimeEl = root.querySelector('[js-shirt-express-delivery-time]');
        const defaultTimeEl = root.querySelector('[js-shirt-default-delivery-time]');
        const mtoTimeEl = root.querySelector('[js-shirt-delivery-time]');

        if (isMTO) {
          formData.set('items[0][properties][_Delivery type]', 'MTO');
          formData.set('items[0][properties][_Delivery days]', mtoDays);
          if (mtoTimeEl && mtoTimeEl.textContent) {
            formData.set('items[0][properties][Estimated delivery]', mtoTimeEl.textContent.trim());
          }
          formData.delete('items[0][properties][Priority express shipping]');
          formData.delete('items[0][properties][Estimated standard delivery]');
          formData.delete('attributes[Express Delivery]');
        } else {
          formData.set('items[0][properties][_Delivery type]', 'RTS');
          formData.set('items[0][properties][_Delivery days]', rtsDays);
          if (expressTimeEl && expressTimeEl.textContent) {
            formData.set('items[0][properties][Priority express shipping]', expressTimeEl.textContent.trim());
          }
          if (defaultTimeEl && defaultTimeEl.textContent) {
            formData.set('items[0][properties][Estimated standard delivery]', defaultTimeEl.textContent.trim());
          }
          formData.delete('items[0][properties][Estimated delivery]');
          formData.set('attributes[Express Delivery]', 'Express Delivery');
        }
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const errorWrap = form.querySelector('[js-pdp-form-error] ul');
            if (errorWrap) {
              errorWrap.innerHTML = `<li>${response.description || response.message || 'Unable to add this shirt.'}</li>`;
            }
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          }
          closePopup();
        })
        .catch(() => {
          const errorWrap = form.querySelector('[js-pdp-form-error] ul');
          if (errorWrap) {
            errorWrap.innerHTML = '<li>Unable to add this shirt. Please try again.</li>';
          }
        })
        .finally(() => {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        });
    });
  };

  const loadShirt = (item) => {
    const handle = item.dataset.shirtHandle;
    const sameAsModel = item.dataset.sameAsModel === 'true';
    const shirtUrl = item.dataset.shirtUrl;
    if (!handle && !shirtUrl) return;
    body.innerHTML = '';
    popup.classList.add('is-loading');
    openPopup();

    const url = shirtUrl
      ? `${shirtUrl}${shirtUrl.includes('?') ? '&' : '?'}view=shirt-pdp-popup`
      : `/products/${handle}?view=shirt-pdp-popup`;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Unable to load shirt');
        return response.text();
      })
      .then((html) => {
        body.innerHTML = html;
        const stamp = body.querySelector('[js-same-as-model-stamp]');
        if (stamp) stamp.classList.toggle('is-visible', sameAsModel);
        initAccordion(body);
        initSizePicker(body);
        initSizeGuideModal(body);
        initShirtForm(body);
      })
      .catch(() => {
        body.innerHTML = '<p class="shirt-pdp-popup__error">Unable to load this shirt. Please try again.</p>';
      })
      .finally(() => {
        popup.classList.remove('is-loading');
      });
  };

  selector.querySelectorAll('[js-more-shirts-item]').forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      loadShirt(item);
    });
  });

  closeBtns.forEach((btn) => btn.addEventListener('click', closePopup));

  popup.addEventListener('click', (event) => {
    if (event.target === popup) closePopup();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const sizeModal = popup.querySelector('[js-shirt-size-chart-modal]:not(.hide)');
      if (sizeModal) {
        sizeModal.classList.add('hide');
        return;
      }
      if (popup.classList.contains('popup-open')) {
        closePopup();
      }
    }
  });

  popup.addEventListener('shirt-pdp-popup:close', closePopup);

  if (prevBtn && nextBtn && track) {
    prevBtn.addEventListener('click', () => scrollByCard(-1));
    nextBtn.addEventListener('click', () => scrollByCard(1));
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }
})();
